import { render, staticRenderFns } from "./target_index.vue?vue&type=template&id=034e8b78&scoped=true"
import script from "./target_index.vue?vue&type=script&lang=js"
export * from "./target_index.vue?vue&type=script&lang=js"
import style0 from "./target_index.vue?vue&type=style&index=0&id=034e8b78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e8b78",
  null
  
)

export default component.exports